"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _material = require("@mui/material");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRNumberField = function PRNumberField(props) {
  var isValid = function isValid(value) {
    var re = /^PR-[0-9]{6,9}$/;
    return value && re.test(value) ? undefined : "Enter a valid PR number";
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: "prNumber",
    validate: isValid,
    label: "PR Number",
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "start"
      }, "PR - ")
    },
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    fullWidth: true,
    required: true,
    parse: function parse(value) {
      return value && "PR-" + value;
    },
    format: function format(value) {
      return value ? value.replace("PR-", "") : "";
    },
    inputProps: {
      maxLength: 9
    }
  });
};

var _default = PRNumberField;
exports.default = _default;